import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Text from 'antd/lib/typography/Text';
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import VoucherAmountCustom from '../../components/voucher-amount-custom/voucher-amount-custom';
import VoucherAmountFixed from '../../components/voucher-amount-fixed/voucher-amount-fixed';
import ZLSection from '../../containers/zl-section/zl-section';
import { IApplicationState } from '../../store';

export interface IGiftVoucherAmountSectionProps {
    active: boolean;
    scrollTo?: boolean;
    isGlobal?: boolean;
}

const GiftVoucherAmountSection: React.FunctionComponent<IGiftVoucherAmountSectionProps> = (props) => {
    const { t } = useTranslation();
    const { active, scrollTo } = props;

    const isGlobal = props.isGlobal ?? false;

    const selectedSiteCurrencySymbol = useSelector((state: IApplicationState) => state.sites.selectedSite?.currencySymbol);
    const selectedCurrencySymbol = useSelector((state: IApplicationState) => state.giftVoucher?.selectedVoucherCurrency?.symbol);


    const currencySymbol = selectedCurrencySymbol ?? selectedSiteCurrencySymbol;

    const voucherConfig = useSelector((state: IApplicationState) => state.giftVoucher.configDetails);
    const loading = useSelector((state: IApplicationState) => state.giftVoucher.configLoading);

    return (
        <ZLSection title={t('giftVoucherSection.purchase.fixedAmountHeading')} active={active} scrollTo={scrollTo}>
            <div style={{ position: 'relative', minHeight: loading ? '200px' : 'auto' }}>
                {loading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10
                    }}>
                        <LoadingSpinner />
                    </div>
                )}
                <Row justify="start" align="top" style={{ opacity: loading ? 0.3 : 1, pointerEvents: loading ? 'none' : 'auto' }}>
                    <Col xs={24}>
                        <VoucherAmountFixed voucherConfig={voucherConfig} isGlobal={isGlobal} />
                    </Col>
                    <Col span={24}>
                        <Text className={`zl-voucher-amount-text`}>
                            {t('giftVoucherSection.purchase.customAmountHeading')}
                        </Text>
                        <VoucherAmountCustom voucherConfig={voucherConfig} currencySymbol={currencySymbol} isGlobal={isGlobal} />
                    </Col>
                </Row>
            </div>
        </ZLSection>
    );
};

export default GiftVoucherAmountSection;
